import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Detail } from "MODULES/shared/components/DetailTable";
import { Map } from "immutable";
import { ShippingPreference } from "MODULES/Orders/shared/ShippingPreference";
import { CompanyName } from "MODULES/shared/components";
import {
  CARE_OF,
  CITY,
  COMPANY_NAME,
  CONTACT_NAME,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";
import { properCase } from "LIB/formatters/text";
import { dropShip } from "MODULES/SalesOrders/helpers";

export default function ShippingAddress({
  record,
  shippingType,
  renderPreferences = true,
  shippingMethod = null
}) {
  const shippingAddress = record.get(`${shippingType}_address`) || Map();

  const shipToShippingType = record.get(`${shippingType}_type`);
  const method =
    shippingMethod || record.get(`${shippingType}_shipping_method`) || Map();
  const fob = record.get(`${shippingType}_fob`);

  return (
    <div>
      <table className="table table-condensed">
        <tbody>
          {record.get(`${shippingType}_company`) && (
            <tr>
              <th className="text-right">Company</th>
              <td>
                <CompanyName
                  company={record.toJS()[`${shippingType}_company`]}
                />
              </td>
            </tr>
          )}
          {shippingAddress.get(COMPANY_NAME) &&
            dropShip(shipToShippingType) && [
              <tr>
                <th className="text-right">Company</th>
                <td>{shippingAddress.get(COMPANY_NAME)}</td>
              </tr>,
              <Detail
                label={properCase(CONTACT_NAME)}
                value={shippingAddress.get(CONTACT_NAME)}
              />
            ]}
          {shippingAddress.get(CARE_OF) &&
            dropShip(shipToShippingType) && (
              <tr>
                <th className="text-right">c/o</th>
                <td>{shippingAddress.get(CARE_OF)}</td>
              </tr>
            )}
          <Fragment>
            <tr>
              <th className="text-right">Address Line</th>
              <td>
                {shippingAddress.get(LINE1)}
                {shippingAddress.get(LINE2) && [
                  <br />,
                  shippingAddress.get(LINE2)
                ]}
              </td>
            </tr>
            <tr>
              <th className="text-right">City</th>
              <td>{shippingAddress.get(CITY)}</td>
            </tr>
            <tr>
              <th className="text-right">State/ Province/ Region</th>
              <td>{shippingAddress.get(STATE)}</td>
            </tr>
            <tr>
              <th className="text-right">ZIP/ Postal Code</th>
              <td>{shippingAddress.get(POSTAL_CODE)}</td>
            </tr>
            <tr>
              <th className="text-right">Country</th>
              <td>{shippingAddress.get(COUNTRY)}</td>
            </tr>
          </Fragment>
          {fob && (
            <tr>
              <th className="text-right">FOB</th>
              <td>{fob}</td>
            </tr>
          )}
        </tbody>
      </table>
      {renderPreferences && (
        <ShippingPreference shippingMethod={method.toJS()} />
      )}
      {record.get("code").slice(0, 2) === "MS" &&
        record.get("shipped") && (
          <table className="table table-condensed">
            <tbody>
              <tr>
                <th className="text-right">Outgoing AWB #</th>
                <td>{record.toJS().outgoing_awb_number}</td>
              </tr>
            </tbody>
          </table>
        )}
    </div>
  );
}

ShippingAddress.propTypes = {
  record: PropTypes.instanceOf(Object),
  shippingType: PropTypes.string.isRequired,
  renderPreferences: PropTypes.bool,
  shippingMethod: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingAddress.jsx